import React from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { GraduationCap, Award, Calendar, MapPin } from 'lucide-react';
import { education, certifications } from '../mock/mockData';

const Education = () => {
  return (
    <div className="relative z-10 min-h-screen pt-24 pb-16 px-6">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-white mb-4">Education & Certifications</h1>
          <p className="text-xl text-gray-300">Academic Excellence & Professional Recognition</p>
          <div className="h-1 w-32 bg-gradient-to-r from-blue-600 to-sky-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Education Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-white mb-8 flex items-center">
            <GraduationCap className="h-8 w-8 text-sky-400 mr-3" />
            Academic Qualifications
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            {education.map((edu) => (
              <Card
                key={edu.id}
                className={`p-6 border-blue-900/30 shadow-xl bg-[#060f1e]/80 backdrop-blur hover:shadow-2xl hover:shadow-blue-500/10 transition-all duration-300 ${
                  edu.type === 'honorary' ? 'md:col-span-2 bg-gradient-to-br from-blue-950/40 to-sky-950/40' : ''
                }`}
              >
                <div className="flex items-start justify-between mb-3">
                  <Badge
                    className={`${
                      edu.type === 'honorary'
                        ? 'bg-gradient-to-r from-blue-600 to-sky-500 text-white'
                        : 'bg-blue-900/30 text-sky-300'
                    } border-0`}
                  >
                    {edu.year}
                  </Badge>
                  {edu.type === 'honorary' && (
                    <Award className="h-8 w-8 text-sky-400" />
                  )}
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{edu.degree}</h3>
                <div className="flex items-center space-x-4 text-sm text-gray-300 mb-3">
                  <div className="flex items-center space-x-1">
                    <GraduationCap className="h-4 w-4 text-sky-400" />
                    <span>{edu.institution}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <MapPin className="h-4 w-4 text-blue-400" />
                    <span>{edu.location}</span>
                  </div>
                </div>
                <p className="text-gray-200 text-sm">{edu.description}</p>
              </Card>
            ))}
          </div>
        </div>

        {/* Certifications Section */}
        <div>
          <h2 className="text-3xl font-bold text-white mb-8 flex items-center">
            <Award className="h-8 w-8 text-blue-400 mr-3" />
            Professional Certifications & Memberships
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {certifications.map((cert) => (
              <Card
                key={cert.id}
                className="p-6 border-blue-900/30 shadow-lg bg-[#060f1e]/80 backdrop-blur hover:shadow-xl hover:shadow-blue-500/10 transition-all duration-300 hover:scale-105"
              >
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-900/40 to-sky-900/40 rounded-full mb-4">
                  <Award className="h-6 w-6 text-sky-400" />
                </div>
                <h3 className="font-bold text-white mb-2 text-lg">{cert.title}</h3>
                <p className="text-sm text-gray-300 mb-2">{cert.organization}</p>
                <Badge className="bg-blue-900/30 text-sky-300 border-0 text-xs">{cert.period}</Badge>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;